module.exports = __webpack_public_path__ + "img/env.e7bb5cdd.png";